import React from 'react';

export default function GoldMedalSvg({ width = "46", height = "43", className = "", style = {}, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      <g clipPath="url(#clip0_gold_endurance)">
        <path
          d="M40.6001 19.3333C40.6001 28.9063 32.7204 36.6667 23.0001 36.6667C13.2799 36.6667 5.40015 28.9063 5.40015 19.3333C5.40015 9.7604 13.2799 2 23.0001 2C32.7204 2 40.6001 9.7604 40.6001 19.3333Z"
          fill="#FFBB0D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9038 19.3333C41.9038 29.6154 33.4404 37.9506 23.0001 37.9506C12.5599 37.9506 4.09644 29.6154 4.09644 19.3333C4.09644 9.0513 12.5599 0.716064 23.0001 0.716064C33.4404 0.716064 41.9038 9.0513 41.9038 19.3333ZM23.0001 36.6667C32.7203 36.6667 40.6001 28.9063 40.6001 19.3333C40.6001 9.76041 32.7203 2.00001 23.0001 2.00001C13.2799 2.00001 5.40014 9.76041 5.40014 19.3333C5.40014 28.9063 13.2799 36.6667 23.0001 36.6667Z"
          fill="#E89B05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.70395 19.9753C6.34395 19.9753 6.0521 19.6879 6.0521 19.3334C6.0521 10.115 13.64 2.64201 23.0002 2.64201C23.3603 2.64201 23.6521 2.92943 23.6521 3.28399C23.6521 3.63854 23.3603 3.92596 23.0002 3.92596C14.3601 3.92596 7.35581 10.8241 7.3558 19.3334C7.3558 19.6879 7.06396 19.9753 6.70395 19.9753Z"
          fill="#E8AA0A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.2965 18.6914C39.6565 18.6914 39.9484 18.9788 39.9484 19.3334C39.9484 28.5518 32.3604 36.0247 23.0002 36.0247C22.6402 36.0247 22.3484 35.7373 22.3484 35.3828C22.3484 35.0282 22.6402 34.7408 23.0002 34.7408C31.6404 34.7408 38.6447 27.8427 38.6447 19.3334C38.6447 18.9788 38.9365 18.6914 39.2965 18.6914Z"
          fill="#E8AA0A"
        />
        <path
          d="M36.0372 19.3334C36.0372 26.4245 30.2003 32.1729 23.0002 32.1729C15.8 32.1729 9.96313 26.4245 9.96313 19.3334C9.96313 12.2423 15.8 6.4939 23.0002 6.4939C30.2003 6.4939 36.0372 12.2423 36.0372 19.3334Z"
          fill="#FFDD28"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.3409 19.3333C37.3409 27.1335 30.9203 33.4567 23.0002 33.4567C15.08 33.4567 8.65942 27.1335 8.65942 19.3333C8.65942 11.5331 15.08 5.20984 23.0002 5.20984C30.9203 5.20984 37.3409 11.5331 37.3409 19.3333ZM23.0002 32.1728C30.2003 32.1728 36.0372 26.4244 36.0372 19.3333C36.0372 12.2422 30.2003 6.49379 23.0002 6.49379C15.8 6.49379 9.96313 12.2422 9.96313 19.3333C9.96313 26.4244 15.8 32.1728 23.0002 32.1728Z"
          fill="#E89B05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.0001 30.2469C29.1202 30.2469 34.0816 25.3608 34.0816 19.3334C34.0816 18.9788 34.3734 18.6914 34.7334 18.6914C35.0934 18.6914 35.3853 18.9788 35.3853 19.3334C35.3853 26.0699 29.8402 31.5309 23.0001 31.5309C22.6401 31.5309 22.3482 31.2435 22.3482 30.8889C22.3482 30.5344 22.6401 30.2469 23.0001 30.2469Z"
          fill="#ECC704"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.0002 8.41981C16.88 8.41981 11.9187 13.306 11.9187 19.3334C11.9187 19.6879 11.6268 19.9754 11.2668 19.9754C10.9068 19.9754 10.615 19.6879 10.615 19.3334C10.615 12.5969 16.16 7.13586 23.0002 7.13586C23.3602 7.13586 23.652 7.42329 23.652 7.77784C23.652 8.13239 23.3602 8.41981 23.0002 8.41981Z"
          fill="#FFEF9C"
        />
        <path
          d="M3.07712 36.4246L1.39809 33.1174C1.21524 32.7572 1.48116 32.3335 1.89002 32.3335L9.2501 32.3335C9.55386 32.3335 9.8001 32.576 9.8001 32.8752L9.8001 40.4585C9.8001 40.7576 9.55386 41.0002 9.2501 41.0002L1.89002 41.0002C1.48116 41.0002 1.21524 40.5764 1.39809 40.2163L3.07712 36.9091C3.15454 36.7566 3.15454 36.5771 3.07712 36.4246Z"
          fill="#FFDD28"
        />
        <path
          d="M42.9231 36.4246L44.6021 33.1174C44.785 32.7572 44.519 32.3335 44.1102 32.3335L36.7501 32.3335C36.4463 32.3335 36.2001 32.576 36.2001 32.8752L36.2001 40.4585C36.2001 40.7576 36.4463 41.0002 36.7501 41.0002L44.1102 41.0002C44.519 41.0002 44.785 40.5764 44.6021 40.2163L42.9231 36.9091C42.8457 36.7566 42.8457 36.5771 42.9231 36.4246Z"
          fill="#FFDD28"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.97016 36.6669L0.414112 33.602C-0.134426 32.5215 0.663326 31.2502 1.88992 31.2502L9.25 31.2502C10.1613 31.2502 10.9 31.9778 10.9 32.8752L10.9 40.4586C10.9 41.356 10.1613 42.0836 9.25 42.0836L1.88991 42.0836C0.663326 42.0836 -0.134427 40.8123 0.414112 39.7319L1.97016 36.6669ZM2.09283 36.9085C2.09293 36.9087 2.09304 36.909 2.09315 36.9092L2.58509 36.6669L2.09314 36.9091L2.09283 36.9085ZM44.0298 36.6669L45.5859 33.602C46.1344 32.5215 45.3367 31.2502 44.1101 31.2502L36.75 31.2502C35.8387 31.2502 35.1 31.9778 35.1 32.8752L35.1 40.4586C35.1 41.356 35.8387 42.0836 36.75 42.0836L44.1101 42.0836C45.3367 42.0836 46.1344 40.8123 45.5859 39.7319L44.0298 36.6669ZM44.602 33.1175L42.923 36.4247C42.8456 36.5772 42.8456 36.7567 42.923 36.9092L44.602 40.2163C44.7849 40.5765 44.5189 41.0002 44.1101 41.0002L36.75 41.0002C36.4462 41.0002 36.2 40.7577 36.2 40.4586L36.2 32.8752C36.2 32.5761 36.4462 32.3336 36.75 32.3336L44.1101 32.3336C44.5189 32.3336 44.7849 32.7573 44.602 33.1175ZM1.39798 33.1175L3.07701 36.4247C3.15443 36.5772 3.15443 36.7567 3.07701 36.9091L1.39798 40.2163C1.21513 40.5765 1.48106 41.0002 1.88992 41.0002L9.25 41.0002C9.55375 41.0002 9.8 40.7577 9.8 40.4586L9.8 32.8752C9.8 32.5761 9.55375 32.3336 9.25 32.3336L1.88992 32.3336C1.48106 32.3336 1.21513 32.7573 1.39798 33.1175Z"
          fill="#E89B05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.18479 32.8234C2.28551 32.666 2.4612 32.5706 2.6501 32.5706H4.9876C5.29136 32.5706 5.5376 32.8131 5.5376 33.1122C5.5376 33.4114 5.29136 33.6539 4.9876 33.6539H3.52281L4.65877 35.9931C4.78983 36.263 4.67393 36.5864 4.3999 36.7155C4.12587 36.8445 3.79748 36.7304 3.66642 36.4605L2.15392 33.3459C2.07242 33.1781 2.08408 32.9808 2.18479 32.8234Z"
          fill="#ECC704"
        />
        <path
          d="M38.3999 38.2919L38.3999 30.7085C38.3999 30.4094 38.1537 30.1669 37.8499 30.1669L8.1499 30.1669C7.84614 30.1669 7.5999 30.4094 7.5999 30.7085L7.5999 38.2919C7.5999 38.591 7.84614 38.8335 8.1499 38.8335L37.8499 38.8335C38.1537 38.8335 38.3999 38.591 38.3999 38.2919Z"
          fill="#FFDD28"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.5 30.7085L39.5 38.2918C39.5 39.1893 38.7613 39.9168 37.85 39.9168L8.15 39.9168C7.23873 39.9168 6.5 39.1893 6.5 38.2918L6.5 30.7085C6.5 29.811 7.23873 29.0835 8.15 29.0835L37.85 29.0835C38.7613 29.0835 39.5 29.811 39.5 30.7085ZM38.4 30.7085L38.4 38.2918C38.4 38.591 38.1538 38.8335 37.85 38.8335L8.15 38.8335C7.84624 38.8335 7.6 38.591 7.6 38.2918L7.6 30.7085C7.6 30.4093 7.84624 30.1668 8.15 30.1668L37.85 30.1668C38.1538 30.1668 38.4 30.4093 38.4 30.7085Z"
          fill="#E89B05"
        />
        <path
          d="M36.8804 34.7059C36.569 34.7059 36.3165 34.4633 36.3165 34.164C36.3165 33.8648 36.569 33.6222 36.8804 33.6222C37.1919 33.6222 37.4443 33.8648 37.4443 34.164C37.4443 34.4633 37.1919 34.7059 36.8804 34.7059Z"
          fill="#FFBB0D"
        />
        <path
          d="M34.7348 34.4891C34.3474 34.4891 34.0334 34.1873 34.0334 33.8151C34.0334 33.4429 34.3474 33.1411 34.7348 33.1411C35.1222 33.1411 35.4363 33.4429 35.4363 33.8151C35.4363 34.1873 35.1222 34.4891 34.7348 34.4891Z"
          fill="#FFBB0D"
        />
        <path
          d="M35.6908 36.0301C35.4971 36.0301 35.34 35.8792 35.34 35.6931C35.34 35.507 35.4971 35.3561 35.6908 35.3561C35.8845 35.3561 36.0415 35.507 36.0415 35.6931C36.0415 35.8792 35.8845 36.0301 35.6908 36.0301Z"
          fill="#FFBB0D"
        />
        <path
          d="M35.0855 32.4659C34.8918 32.4659 34.7348 32.315 34.7348 32.1289C34.7348 31.9427 34.8918 31.7919 35.0855 31.7919C35.2793 31.7919 35.4363 31.9427 35.4363 32.1289C35.4363 32.315 35.2793 32.4659 35.0855 32.4659Z"
          fill="#FFBB0D"
        />
        <path
          d="M33.2425 35.693C33.0488 35.693 32.8918 35.5422 32.8918 35.356C32.8918 35.1699 33.0488 35.019 33.2425 35.019C33.4362 35.019 33.5933 35.1699 33.5933 35.356C33.5933 35.5422 33.4362 35.693 33.2425 35.693Z"
          fill="#FFBB0D"
        />
        <path
          d="M32.8917 33.9593C32.698 33.9593 32.541 33.8084 32.541 33.6223C32.541 33.4362 32.698 33.2853 32.8917 33.2853C33.0854 33.2853 33.2424 33.4362 33.2424 33.6223C33.2424 33.8084 33.0854 33.9593 32.8917 33.9593Z"
          fill="#FFBB0D"
        />
        <path
          d="M30.5008 37.8683C30.3071 37.8683 30.1501 37.7174 30.1501 37.5313C30.1501 37.3452 30.3071 37.1943 30.5008 37.1943C30.6945 37.1943 30.8516 37.3452 30.8516 37.5313C30.8516 37.7174 30.6945 37.8683 30.5008 37.8683Z"
          fill="#FFBB0D"
        />
        <path
          d="M37.4789 36.5818C37.2852 36.5818 37.1281 36.4309 37.1281 36.2448C37.1281 36.0587 37.2852 35.9078 37.4789 35.9078C37.6726 35.9078 37.8296 36.0587 37.8296 36.2448C37.8296 36.4309 37.6726 36.5818 37.4789 36.5818Z"
          fill="#FFBB0D"
        />
        <path
          d="M34.1641 37.3199C33.8488 37.3199 33.5933 37.0744 33.5933 36.7715C33.5933 36.4686 33.8488 36.223 34.1641 36.223C34.4793 36.223 34.7349 36.4686 34.7349 36.7715C34.7349 37.0744 34.4793 37.3199 34.1641 37.3199Z"
          fill="#FFBB0D"
        />
        <path
          d="M36.6123 37.8684C36.2971 37.8684 36.0415 37.6228 36.0415 37.3199C36.0415 37.017 36.2971 36.7715 36.6123 36.7715C36.9276 36.7715 37.1831 37.017 37.1831 37.3199C37.1831 37.6228 36.9276 37.8684 36.6123 37.8684Z"
          fill="#FFBB0D"
        />
        <path
          d="M31.6196 36.79C31.3044 36.79 31.0488 36.5444 31.0488 36.2416C31.0488 35.9387 31.3044 35.6931 31.6196 35.6931C31.9349 35.6931 32.1904 35.9387 32.1904 36.2416C32.1904 36.5444 31.9349 36.79 31.6196 36.79Z"
          fill="#FFBB0D"
        />
        <path
          d="M32.5411 38.0348C32.3474 38.0348 32.1904 37.8839 32.1904 37.6978C32.1904 37.5117 32.3474 37.3608 32.5411 37.3608C32.7348 37.3608 32.8918 37.5117 32.8918 37.6978C32.8918 37.8839 32.7348 38.0348 32.5411 38.0348Z"
          fill="#FFBB0D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.94385 30.9455C7.94385 30.6463 8.19009 30.4038 8.49385 30.4038H29.1188C29.4226 30.4038 29.6688 30.6463 29.6688 30.9455C29.6688 31.2446 29.4226 31.4871 29.1188 31.4871H9.04385V35.2788C9.04385 35.578 8.7976 35.8205 8.49385 35.8205C8.19009 35.8205 7.94385 35.578 7.94385 35.2788V30.9455Z"
          fill="#FFEF9C"
        />
        <path
          d="M24.41 23.988H22.4093V16.3929L20.021 17.1225V15.5203L24.1954 14.0476H24.41V23.988Z"
          fill="#FFEF9C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.5916 23.988C25.5916 24.6307 25.0626 25.1516 24.4101 25.1516H22.4094C21.7569 25.1516 21.2279 24.6307 21.2279 23.988V17.9721L20.3711 18.2338C20.0125 18.3433 19.6224 18.2785 19.3202 18.0592C19.018 17.8399 18.8396 17.4922 18.8396 17.1225V15.5203C18.8396 15.0289 19.153 14.5905 19.6227 14.4248L23.7971 12.9522C23.9249 12.9071 24.0597 12.884 24.1955 12.884H24.4101C25.0626 12.884 25.5916 13.405 25.5916 14.0476V23.988ZM22.4094 16.393V23.988H24.4101V14.0476H24.1955L20.0211 15.5203V17.1225L22.4094 16.393Z"
          fill="#E89B05"
        />
      </g>
      <defs>
        <clipPath id="clip0_gold_endurance">
          <rect width="46" height="43" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
